import  { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Card, Grid, Typography } from "@mui/material";
import { useAuth } from "../../../../AuthProvider";

const fixedExams = [
  {
    step: "01",
    title: "Schedule",
    description: "View and manage all examination schedules and timelines",
    color: "#3f51b5",
    route: "/AllExaminationScheduleList",
  },
  {
    step: "02",
    title: "Ongoing Exams",
    description: "Access current examinations and active test details",
    color: "#3f51b5",
    route: "/TodayandTmrwExaminationScheduleList",
  },
];





const ExaminationDashboard = () => {
  const navigate = useNavigate();
  const [dynamicExams, setDynamicExams] = useState([]);
  const { oId, pId } = useAuth();

  const [loading, setLoading] = useState(true);

 



  useEffect(() => {
  const fetchExamTypes = async () => {
    try {
      const baseUrl = process.env.REACT_APP_API_BASE_URL;
      const response = await fetch(`${baseUrl}/api/dynamic-classReg/getAllExamsTypes/${oId}/${pId}`);
      if (!response.ok) throw new Error("Network response was not ok");

      const data = await response.json();

      // Convert to full exam card objects
      const formattedData = data.map((title, index) => ({
        step: (fixedExams.length + index + 1).toString().padStart(2, "0"),
        title: title,
        description: `View and manage all examination schedules of ${title}`,
        color: "#3f51b5",
        route: `/ExaminationMiniDashboard/${title}`,
      }));

      setDynamicExams(formattedData);
    } catch (error) {
      console.error("Error fetching exam types:", error);
    } finally {
      setLoading(false);
    }
  };

  fetchExamTypes();
}, []);





  const exams = [...fixedExams, ...dynamicExams];

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      bgcolor="#F2F4F7"
      sx={{ margin: "6% 1% 0% 1%" }}
    >
      <Card
        sx={{
          p: 4,
          boxShadow: 6,
          backgroundColor: "#ffffff",
          borderRadius: 4,
        }}
      >
        <Typography
          variant="h4"
          fontWeight="bold"
          textAlign="center"
          mb={4}
          color="#2C3E50"
        >
          Examination Dashboard
        </Typography>

        <Grid container spacing={3}>
          {exams.map((item, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                sx={{
                  height: "100%",
                  p: 2,
                  borderRadius: 2,
                  boxShadow: 3,
                  cursor: "pointer",
                  transition: "0.3s",
                  "&:hover": {
                    boxShadow:
                      "0px 8px 16px rgba(0, 150, 255, 0.5), 0px 12px 24px rgba(255, 0, 150, 0.5)",
                    transform: "translateY(-3px)",
                  },
                }}
                // onClick={() => navigate(item.route)}
                onClick={() => {
                    // setSelectedExamTitle(item.title);
                    navigate(item.route);
                  }}

              >
                <Box display="flex" alignItems="center" mb={2}>
                  <Box
                    sx={{
                      backgroundColor: item.color,
                      color: "white",
                      width: 50,
                      height: 50,
                      borderRadius: 1,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      mr: 2,
                      fontWeight: "bold",
                      fontSize: "1.2rem",
                    }}
                  >
                    {item.step}
                  </Box>
                  <Typography variant="h6" fontWeight="bold">
                    {item.title}
                  </Typography>
                </Box>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ lineHeight: 1.5 }}
                >
                  {item.description}
                </Typography>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Card>
    </Box>
  );
};

export default ExaminationDashboard;